export const UPLOAD_DATA_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + 'api/users/DistributorUser/UploadFile';
export const GET_LAST_TEN_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + 'api/distributors/DistributorFiles/GetLastTen';